/*
 * @Author: zhoupeng
 * @Date: 2018-09-11 18:08:02
 * @Last Modified by: zhoupeng
 * @Last Modified time: 2018-10-07 18:16:01
 */

<template>
  <div :class="`coupon-item ${used?'gray-boxshadow':''}`">
    <div class="item-main">
      <div class="coupon-bg">
        <div
          :class="`only-support-offline ${used ? 'used' : 'not-used'}`"
          v-if="item.checkType ==CouponUseRangeEnum.OFFLINE.code"
        >仅支持线下核销</div>
        <img  v-if="version==='new'" :src="used?notUseItemBg:'https://image.xiaomaiketang.com/xm/SsdDAKD28d.png'" alt/>
        <img  v-else :src="used?notUseItemBg:unuseItemBg" alt />
        <div :class="`bg-desc ${item.consumeAmount?'have-min-price':''}`" v-if="item.type == 1">
          <span>￥</span>
          <span
            class="bg-desc-amount"
            :class="(item.decimalDiscountAmount &&  item.decimalDiscountAmount.toString().length >= 5) ? 'long-amount' : 'asdf'"
          >{{item.decimalDiscountAmount}}</span>
        </div>
        <div class="bg-desc" v-else-if="item.type == 2">
          {{item.discount/10}}
          <span>&nbsp;&nbsp;折</span>
        </div>
        <div class="bg-desc" v-else-if="item.type == 3">
          {{item.classHour/100}}
          <span>&nbsp;&nbsp;课时</span>
        </div>
        <div class="bg-desc gift-name" v-else>
          <span>{{item.giftName}}</span>
        </div>
      </div>
      <div class="coupon-desc">
        <p class="name">
          <span :class="`type type${item.type} ${used?'gray-type':''}`">{{couponType[item.type]}}</span>
          <span class="name-content">{{item.title}}</span>
        </p>
        <p class="limit-time gray" v-if="expireDate">{{expireDate}}到期</p>
        <p class="limit-time gray" v-else>{{periodBegin}}-{{periodEnd}}</p>
        <p class="condition gray" @click="handleShowExplain(item)">
          <img
            src="http://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571379073172.png"
            alt
            class="condition-icon"
          />
          <span
            class="condition-text"
          >{{item.checkType ==CouponUseRangeEnum.OFFLINE.code ? '全部商品可用' : (item.goodsScope === -1 ? '全部商品可用':'部分商品可用')}} · {{item.minPoint === 0 ? '无使用门槛': `满${item.decimalMinPoint}元使用`}}</span>
        </p>
        <p class="explain gray">
          <span @click="handleShowExplain(item)">优惠券详情</span>
          <span class="icon iconfont gray">&#xe611;</span>
          <img
            :src="chooseCoupon.userCouponId == item.userCouponId ? 'https://image.xiaomaiketang.com/xm/kmCe4nMFhS.png' : 'http://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571888774264.png'"
            alt
            class="item-check"
            v-if="canChoose&&version==='new'"
            @click="handleChooseCoupon(item)"
          />
          <img
            :src="chooseCoupon.userCouponId == item.userCouponId ? 'http://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571889414648.png' : 'http://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571888774264.png'"
            alt
            class="item-check"
            v-if="canChoose&&version==='old'"
            @click="handleChooseCoupon(item)"
          />

        </p>
        <img v-if="used && showUsed " class="used-icon" :src="overdue?overdueCoupon:usedCoupon" alt />
      </div>
    </div>
  </div>
</template>

<script>
import unuseItemBg from "@/images/benefits/coupon_unuse_item_bg.png";
import notUseItemBg from "@/images/benefits/coupon_not_use_item_bg.png";
import usedCoupon from "@/images/benefits/coupon_used.png";
import overdueCoupon from "@/images/benefits/coupon_overdue.png";
import UserService from "@/service/UserService";
import CouponUseRangeEnum from "@/enum/CouponUseRangeEnum";

export default {
  name: "coupon-item",
  props: {
    item: Object,
    used: Boolean,
    overdue: Boolean,
    showUsed: {
      type: Boolean,
      default: true
    },
    canChoose: false, // 是否可以选择
    chooseCoupon: Object, // 选中的优惠券
    version:String
  },
  components: {
    // Confirm
  },

  data() {
    return {
      unuseItemBg: unuseItemBg,
      notUseItemBg: notUseItemBg,
      usedCoupon: usedCoupon,
      overdueCoupon: overdueCoupon,
      couponType: window.ENUM.CouponType,
      CouponUseRangeEnum,

      showInstName: false,

      periodBegin: this.item.periodBegin
        ? moment(Number(this.item.periodBegin)).format("YYYY.MM.DD")
        : "",
      periodEnd: this.item.periodEnd
        ? moment(Number(this.item.periodEnd)).format("YYYY.MM.DD")
        : "",
      expireDate: this.item.expireDate
        ? moment(Number(this.item.expireDate)).format("YYYY.MM.DD")
        : ""
    };
  },

  methods: {
    handleShowExplain(item) {
      this.$emit("showExplain", item);
    },

    handleToSharePage(id) {
      window.router.push({
        name: "coupon_share",
        params: { id }
      });
    },

    handleChooseCoupon(item) {
      this.$emit("clickCoupon", item);
    }
  }
};
</script>

<style lang='less'>
@import "../../core/variables.less";
@import "../../core/mixins.less";

.coupon-item {
  box-shadow: 0px 6px 20px 0px rgba(50, 150, 250, 0.1);
  background: #fff;
  margin-bottom: 0.2rem;
  .item-main {
    display: flex;
    height: 2rem;
    position: relative;
    .coupon-bg {
      position: relative;
      width: 2.8rem;
      width: 2.8rem;
      display: flex;
      z-index: 100;
      justify-content: center;
      align-items: center;
      background: #f4f6fa;
      .only-support-offline {
        position: absolute;
        left: 0;
        top: 0;
        width: 1.92rem;
        height: 0.4rem;
        color: #fff;
        font-size: 0.22rem;
        text-align: center;

        background-size: 100%;
        z-index: 11;
        &.not-used {
          background-image: url(http://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571363730383.png);
        }
        &.used {
          background-image: url(http://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571364677166.png);
        }
      }
      img {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 100%;
        height: 100%;
      }
      .bg-desc {
        position: relative;
        color: #fff;
        font-size: 0.8rem;
        font-weight: 500;
        display: flex;
        align-items: baseline;
        span {
          font-size: 0.4rem;
        }
        .bg-desc-amount {
          font-size: 0.8rem;
          margin-left: 0.08rem;
        }
        .long-amount {
          font-size: 0.72rem;
        }
      }
      .have-min-price {
        height: 40%;
        line-height: 0.5rem;
        .min-price {
          font-size: 0.26rem;
        }
      }
      .gift-name {
        line-height: 0.5rem;
        width: 60%;
      }
    }
    .coupon-desc {
      flex: 1;
      text-align: left;
      margin-right: 0.3rem;
      position: relative;
      padding-left: 0.16rem;
      .name {
        margin-top: 0.14rem;
        .text-overflow-ellipsis-line(2);
        line-height: 0.36rem;
        position: relative;
        z-index: 100;
        margin-bottom: 0.08rem;
        display: flex;
        .type {
          color: #fff;
          font-size: 0.22rem;
          background: #ffb800;
          padding: 0 0.1rem;
          border-radius: 0.04rem;
          margin-right: 0.1rem;
        }
        .type1 {
          background: #ffb800;
        }
        .type2 {
          background: #ec5743;
        }
        .type3 {
          background: #3296fa;
        }
        .type4 {
          background: #34b88b;
        }
        .gray-type {
          background: #ccc;
        }
        .name-content {
          color: #333;
          font-size: 0.28rem;
        }
      }
      .gray {
        color: #999;
        font-size: 0.22rem;
      }
      .limit-time {
      }
      .condition {
        margin-bottom: 0.08rem;
        display: flex;
        align-items: center;
        .condition-icon {
          width: 0.24rem;
          height: 0.24rem;
          margin-right: 0.08rem;
          margin-bottom: 0.04rem;
        }
        .condition-text {
          font-size: 0.22rem;
        }
      }
      .explain {
        border-top: 1px dashed #eee;
        bottom: 0;
        width: 100%;
        padding-top: 0.08rem;
        > span {
          font-size: 0.22rem;
        }
        &::after {
          display: block;
          content: "";
          clear: both;
          zoom: 1;
        }
        .item-check {
          width: 0.36rem;
          height: 0.36rem;
          vertical-align: top;
          float: right;
        }
      }
    }
    .used-icon {
      position: absolute;
      right: -0.3rem;
      top: 0;
      height: 100%;
    }
  }
  .inst-name {
    padding: 0.25rem 0.4rem;
    font-size: 0.26rem;
    color: #333;
    text-align: left;
    border-top: 0.5px solid #eee;
  }
}
.coupon-item.gray-boxshadow {
  box-shadow: 0px 6px 20px 0px rgba(204, 204, 204, 0.1);
}
</style>


// WEBPACK FOOTER //
// src/module/benefits/CouponItem.vue